import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from '@mui/material';
import React from 'react';
import Button from '@shared/components/Buttons/Button';
import { useMessageService } from '../../services/MessageService/MessageServiceContext';

const MessageModal: React.FC = () => {
  const { modalConfig, closeMessage } = useMessageService();

  if (!modalConfig || modalConfig.modalType === 'action')
    return null;

  const {
    header,
    message,
    confirmLabel = 'OK',
    cancelLabel,
    onConfirm,
    onCancel,
    type = 'info',
    customBody,
    disableEscapeKeyDown = false,
  } = modalConfig;

  const handleConfirm = () => {
    onConfirm?.();
    closeMessage();
  };

  const handleCancel = () => {
    onCancel?.();
    closeMessage();
  };

  const renderIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon color="success" sx={{ fontSize: 48 }} />;
      case 'error':
        return <ErrorIcon color="error" sx={{ fontSize: 48 }} />;
      case 'warning':
        return <WarningIcon color="warning" sx={{ fontSize: 48 }} />;
      case 'info':
      default:
        return <InfoIcon color="info" sx={{ fontSize: 48 }} />;
    }
  };

  return (
    <Dialog className="message-modal" open onClose={disableEscapeKeyDown ? undefined : closeMessage} maxWidth="sm" fullWidth disableEscapeKeyDown={disableEscapeKeyDown}>
      {customBody
        ? (
            <DialogContent>
              {customBody}
            </DialogContent>
          )
        : (
            <>
              {header && <DialogTitle>{header}</DialogTitle>}
              <DialogContent>
                <Box className="modal-icon-wrapper">
                  {renderIcon()}
                </Box>
                <Box className="modal-message">
                  {message as React.ReactNode}
                </Box>
              </DialogContent>
              <Divider className="modal-divider" />
              {confirmLabel && (
                <DialogActions className="modal-actions">
                  {cancelLabel && (
                    <Button size="medium" whiteTheme onClick={handleCancel}>
                      {cancelLabel}
                    </Button>
                  )}
                  <Button
                    variantType={type === 'error' ? undefined : 'success'}
                    size="medium"
                    onClick={handleConfirm}
                  >
                    {confirmLabel}
                  </Button>
                </DialogActions>
              )}
            </>
          )}
    </Dialog>
  );
};

export default MessageModal;
